// extracted by mini-css-extract-plugin
module.exports = {"description":"ContentBlockYoutubeVideo_description__qT_8n"};